module.exports = __webpack_public_path__ + "img/evanghelie-1581-balzonul-lui-lucas-hirscher-big.89c35cf8.png";